

import isNil from 'lodash.isnil';


import {
  DATA_TABLE_DATE_COLUMN_OPTIONS,
  DATA_TABLE_ID_COLUMN_OPTIONS,
  DATA_TABLE_NUMBER_COLUMN_OPTIONS,
  DATA_TABLE_PERCENTAGE_COLUMN_OPTIONS,
  DATA_TABLE_TEXT_COLUMN_OPTIONS } from
'../../../../../common/constants/column/dataTableColumnsOptions';
import { DATA_TABLE_COLUMN_DATA_TYPE } from '../../../../../common/constants/column/dataTableColumnDataType';
import { DATA_TABLE_COLUMN_NUMBER } from '../../../../../common/constants/column/dataTableColumnNumber';

const getDataTableColumnByDataType = (
column) =>


{
  // eslint-disable-next-line default-case
  switch (column.dataType) {
    case DATA_TABLE_COLUMN_DATA_TYPE.TEXT:
      return DATA_TABLE_TEXT_COLUMN_OPTIONS;
    case DATA_TABLE_COLUMN_DATA_TYPE.NUMBER:
      return DATA_TABLE_NUMBER_COLUMN_OPTIONS;
    case DATA_TABLE_COLUMN_DATA_TYPE.PERCENTAGE:
      return DATA_TABLE_PERCENTAGE_COLUMN_OPTIONS;
    case DATA_TABLE_COLUMN_DATA_TYPE.DATE:
      return DATA_TABLE_DATE_COLUMN_OPTIONS;
    default:
      return DATA_TABLE_DATE_COLUMN_OPTIONS;
  }
};

export const isDataTableTreeColumn = (
columnIndex) =>
columnIndex === DATA_TABLE_COLUMN_NUMBER.FIRST;

export const getDataTableColumns = (
columns,
columnFieldId) =>
columns.map((column) => {
  const idOptions = column.field === columnFieldId ? DATA_TABLE_ID_COLUMN_OPTIONS : {};
  const dataTypeOptions = column.dataType ? getDataTableColumnByDataType(column) : {};

  return {
    ...dataTypeOptions,
    ...idOptions,
    ...column,
    isSortable: isNil(column.isSortable) ? true : column.isSortable
  };
});

export const getDataTableColumnByField = (
field,
columns) =>
columns.find((column) => column.field === field);

export const getDataTableColumnsCount = (columns) => columns.length;